import { getField, updateField } from 'vuex-map-fields';
import axios from 'axios';

const state = () => ({
    documentUrl: null,
})

const getters = {
    getField,
}

const actions = {
    confirmSigning({ commit }, key) {
        return new Promise((resolve, reject) => {
            const url = '/quotetoolapi/contract/getsigningconfirmation';

            axios.get(url, {
                params: {
                    key: key
                }
            }).then(response => {
                commit('updateDocumentUrl', response.data.documentUrl);

                resolve(response.data.result);
            }).catch(error => {
                reject(error.message);
            })
        })
    }
}

const mutations = {
    updateField,

    updateDocumentUrl(state, documentUrl) {
        state.documentUrl = documentUrl;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}